import { render } from "./OnboardingLinkAccount.vue?vue&type=template&id=d5891786&scoped=true"
import script from "./OnboardingLinkAccount.vue?vue&type=script&lang=js"
export * from "./OnboardingLinkAccount.vue?vue&type=script&lang=js"

import "./OnboardingLinkAccount.vue?vue&type=style&index=0&id=d5891786&lang=scss&scoped=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5891786"]])

export default __exports__